import { Grid } from "@material-ui/core"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import sunseap_logo from "../../images/sunseap-logo.png"
import sustainable_cities from "../../images/sustainble-cities-and-communities.png"
import affordable_clean_energy from "../../images/affordable-and-clean-energy.png"

const SunseapMapDetail = () => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid item lg={3} xl={2}>
          <Image
            src={sunseap_logo}
            width="956px"
            height="252px"
            isResponsive
            disableLoader
            alt="Sunseap"
            style={{ backgroundSize: "cover", backgroundPosition: "center" }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid item lg={3} xl={2} container spacing={2}>
          <Grid item xs={6}>
            <Image
              src={affordable_clean_energy}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="affordable and clean energy"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <Image
              src={sustainable_cities}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="sustainble cities and communities"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
        <Grid item lg={9} xl={10} container>
          <Grid item xs={12}>
            <StyledDetailHeader>Solar Energy</StyledDetailHeader>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailLocation>Based in Singapore</StyledDetailLocation>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              borderBottom: "3px solid #0F6494",
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            container
          >
            <Grid item xs={6}>
              <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
            </Grid>
            <Grid item xs={6}>
              <StyledDetailSubheaderContent>
                Climate & Water Solutions
                <br />
                Smart & Liveable Cities
              </StyledDetailSubheaderContent>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              About the Company
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Largest and most established clean energy solutions provider in
              Singapore, with regional operations in Asia.
            </StyledDetailSubheaderContent>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              Impact Thesis
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Powering homes and businesses with clean energy and reducing GHG
              emissions.
            </StyledDetailSubheaderContent>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default SunseapMapDetail
